import { render, staticRenderFns } from "./sendcloud.vue?vue&type=template&id=2bf011c6&scoped=true&"
import script from "./sendcloud.vue?vue&type=script&lang=js&"
export * from "./sendcloud.vue?vue&type=script&lang=js&"
import style0 from "./sendcloud.vue?vue&type=style&index=0&id=2bf011c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf011c6",
  null
  
)

export default component.exports